import type { AIAssistantConfig, BotWidgetConfig, BotWidgetInit, GreetingConfig } from './types'

export const DEFAULT_GREETING: GreetingConfig = {
  enabled: true,
  title: 'Hi there! 👋',
  subtitle: 'I can connect you with a TaxBandits representative or answer questions you have on TaxBandits.',
  questions: ['Get started with TaxBandits'],
  delay: 5000,
  autohide: false,
  autohideDelay: 20000,
}

export const WEALTH_RABBIT_GREETING: GreetingConfig = {
  ...DEFAULT_GREETING,
  subtitle: 'I can connect you with a WealthRabbit representative or answer questions you have on WealthRabbit.',
  questions: ['Get started with WealthRabbit'],
}

export const DEFAULT_AI_ASSISTANT: AIAssistantConfig = {
  title: null,
  subtitle: null,
  description: null,
  isShow: false,
  maxShowCount: 1,
}

const DEFAULTS = {
  theme: 'dark' as const,
  authStatus: 'authenticated',
  bottom: '50px',
  isCPA: false,
  isHomeSite: false,
  isSpanControl: false,
  maximumWidth: '600', // px
  topNavHeight: 'var(--layout-top, var(--v-layout-top, 0px))',
  botVersion: 'V2',
  isShowLauncherIcon: true,
  isEnableQuickFixSupport: false,
  isEnableFloatingMode: true,
  launcherPosition: 'bottom-right' as const,
  isEnableLauncherDrag: true,
  chatWidgetPosition: 'bottom-right' as const,
}

export function resolveConfig(init: BotWidgetInit): BotWidgetConfig {
  const isWealthRabbit = init.product?.toLowerCase().replace(/\s+/g, '').includes('wealthrabbit') ?? false
  const baseGreeting = isWealthRabbit ? WEALTH_RABBIT_GREETING : DEFAULT_GREETING
  return {
    ...DEFAULTS,
    ...init,
    // Host fields override the product default one by one. A host's legacy
    // `message` still beats the default subtitle.
    greeting: {
      ...baseGreeting,
      ...init.greeting,
      subtitle: init.greeting?.subtitle ?? init.greeting?.message ?? baseGreeting.subtitle,
    },
    aiAssistant: init.aiAssistant ?? DEFAULT_AI_ASSISTANT,
  }
}

export const ALLOWED_DOMAINS = ['taxbandits', 'stssprint', 'stsstage', 'stsuat', 'securetaxfilings']
